module.exports = __webpack_public_path__ + "img/product-type-wrap-bg.dc9ea507.png";